import { Controller } from "@hotwired/stimulus"

// Point the main image at a thumbnail's larger source while the shopper is on
// that thumbnail, and put it back when they leave the group. Replaces an inline
// turbo:load script that bound listeners globally and never removed them.
export default class extends Controller {
  static targets = ["main", "thumb"]

  connect() {
    // The attribute, not the property: the property resolves to an absolute
    // URL, so restoring it would rewrite the markup the server rendered.
    if (this.hasMainTarget) this.originalSrc = this.mainTarget.getAttribute("src")
  }

  show(event) {
    if (!this.hasMainTarget) return

    const src = event.currentTarget.dataset.src
    if (src) this.mainTarget.src = src
  }

  reset() {
    if (this.hasMainTarget && this.originalSrc) this.mainTarget.src = this.originalSrc
  }
}
